import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createDigest, deleteDigest, queryDigests, updateDigest } from '@wix/ambassador-individual-scheduling-assistant-v1-digest/http';
import { createEnrichedContext, getTaskNarrative, markTaskAsDone } from '@wix/ambassador-isa-digest-engine-v1-digest-engine/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { DigestClientBase } from './DigestClientBase';
export class DigestClient extends HttpBaseClient(DigestClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createDigestImpl", createDigest);
    _defineProperty(this, "queryDigestsImpl", queryDigests);
    _defineProperty(this, "updateDigestImpl", updateDigest);
    _defineProperty(this, "deleteDigestImpl", deleteDigest);
    _defineProperty(this, "getTaskNarrativeImpl", getTaskNarrative);
    _defineProperty(this, "markTaskAsDoneImpl", markTaskAsDone);
    _defineProperty(this, "createEnrichedContextImpl", createEnrichedContext);
  }
}
//# sourceMappingURL=DigestClientHttp.js.map